import * as React from "react";

import "assets/scss/app-rtl.scss";

const ThemeLtr = () => <></>;

export default ThemeLtr;
